import React from "react";
import Preloader from "../helper/Preloader";
import ColorInit from "../helper/ColorInit";
import HeaderTwo from "../components/HeaderTwo";
import Breadcrumb from "../components/Breadcrumb";
import FooterTwo from "../components/FooterTwo";
import BottomFooter from "../components/BottomFooter";
import ShippingOne from "../components/ShippingOne";
import Contact from "../components/CookiePolicy";
import ScrollToTop from "react-scroll-to-top";
import Faq from "../components/Faq";
import { Helmet } from "react-helmet-async";
const ContactPage = () => {
  return (
    <>
      <Helmet>
        <title>Cookie Policy | Awaneez</title>
      </Helmet>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#2694e9" />

      {/* HeaderTwo */}
      <HeaderTwo category={true} />

      {/* Contact */}
      <Contact />

      {/* FooterTwo */}
      <FooterTwo />
    </>
  );
};

export default ContactPage;
